import axios from "axios"
import {Loading, Message, MessageBox} from 'element-ui'
import {getToken} from '@/utils/auth.js'
import store from '../store/index'
import {saveAs} from 'file-saver'

const FormUploadData = require('form-data');
const qs = require('qs');

let isShowLoginTip = false;

/**
 * 响应数据状态
 * @type {{success: {text: string, value: number}, unsigned: {text: string, value: number}, error: {text: string, value: number}}}
 */
const ResponseState = {
  success: {text: 'SUCCESS', value: 0},
  error: {text: 'ERROR', value: 1},
  unsigned: {text: 'UNSIGNED', value: 2}
};

/**
 * 响应数据状态
 * @type {{success: {text: string, value: number}, unsigned: {text: string, value: number}, error: {text: string, value: number}}}
 */
const ResponseStatus = {
  success: {text: 'SUCCESS',  value: 0},
  error: {text: 'ERROR', value: 1},
  unsigned: {text: 'UNSIGNED', value: 2},
};

/**
 * 创建单例
 * @type {AxiosInstance}
 */
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000
});

/**
 * sse服务推送消息
 *
 * @param url
 * @returns {EventSource}
 */
instance['sseEventSource'] = function (url) {
  let t = getToken();
  let eventSource =  new EventSource(process.env.VUE_APP_BASE_API + url + `?authorization=${t}`)
  return eventSource;
}

/**
 * post的表单提交（链接拼接&符号）
 *
 * @param url
 * @param jsonData
 */
instance['postForm'] = function (url, jsonData) {
  return instance.post(url, qs.stringify(jsonData), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
}

/**
 * post的表单提交（formData表单提交，可以包含file）
 *
 * @param url
 * @param formJson
 * @param filesJson 上传的文件列表 {paramName1:[file,file],paramName2:[file]}
 */
instance['uploadWithForm'] = function (url, formJson, filesJson) {
  let data = new FormUploadData();
  formJson = formJson || {};
  let keys = Object.keys(formJson);
  keys.forEach(key => {
    data.append(key, formJson[key]);
  })
  filesJson = filesJson || {};
  let fileKeys = Object.keys(filesJson);
  fileKeys.forEach(key => {
    filesJson[key].forEach(file => {
      data.append(key, file);
    })
  })
  return instance.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}});
}

/**
 * post的表单数据提交（可以包含file）
 *
 * @param url
 * @param formJson {'infoForm': {a:1, b:3}}
 * @param filesJson 上传的文件列表 {paramName1:[file,file],paramName2:[file]}
 *
 * fileList获取：let fileList = this.$util.getFileRaw(data.fileList);
 * 前端传递：request.uploadWithJson(serviceModule + "/file/image/uploadImage", {formData: params}, {fileList: fileList});
 * 后端接收：@RequestPart(value = "formData") BaseReq req, @RequestPart(value = "fileList") List<MultipartFile> fileList
 */
instance['uploadWithJson'] = function (url, formJson, filesJson) {
  let data = new FormUploadData();
  formJson = formJson || {};
  let keys = Object.keys(formJson);
  keys.forEach(key => {
    data.append(key, new Blob([JSON.stringify(formJson[key])], {type: 'application/json'}));
  })
  filesJson = filesJson || {};
  let fileKeys = Object.keys(filesJson);
  fileKeys.forEach(key => {
    filesJson[key].forEach(file => {
      data.append(key, file)
    })
  })
  return instance.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}});
}

/**
 * 请求拦截器
 */
instance.interceptors.request.use(
    config => {
      let t = getToken();
      // console.log("API接口请求==============>", config, t);
      config.headers['authorization'] = t;
      config.headers['Accept'] = 'application/json, text/plain, */*';
      config.headers['HttpOnly'] = 'true';
      config.headers['Secure'] = 'true';
      config.headers['ORG-APP'] = 'sunflower-fe';

      return config
    },
    error => {
      // error request
      console.log("请求终止")
      store.dispatch('doLoading', false).then(r => {})
      return Promise.reject(error)
    }
);

// {
//   data: {
//     createdAt: 1652022023
//     email: "xuyXXXX@sse.com.cn"
//     fullName: "徐XXX"
//     id: 10426463
//     isDelete: false
//     mobile: "18918502811"
//     name: "xuyeXXX"
//     updatedAt: 1652022023
//   },
//   msg: null
//   status: 0
// }
/**
 * 响应拦截器
 */
instance.interceptors.response.use(
    response => {
      store.dispatch('doLoading', false).then(r => {})
      let result = response.data
      // 二进制数据则直接返回
      // mock的时候，需要判断的是，response.config.responseType ===  'blob'但是里面new Blob后是错误的。
      // 所以要下载文件的的话，需要在main.js去掉mock，否则data=3956B，但是new Blob后是6789B
      if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer'
          || response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer'
      ) {
        return response
      }

      if (process.env.VUE_APP_ENV !== "production") {
        try {
          // console.log('API接口返回：【' + response.config.url + "】=====>", JSON.parse(JSON.stringify(result)));
        } catch (err) {
          console.log(err)
        }
      }
      // msg: "请登录"
      // status: 30200
      // 若为30200，则为重定向相应，进行重定向
      if (result.status === ResponseStatus.unsigned.value
         || result.state === ResponseState.unsigned.value) {
        let logoutApi = response.config?.url;
        if(logoutApi.indexOf("/uams/logout") >= 0) {// 如果是主动退出，则不弹出退出提示框
          console.log("---logoutApi response-->", response)
          location.href = result.data;
        } else {
          handleLogout(result);
        }
        return Promise.reject(result.msg)
      }
      if (result.state === ResponseState.success.value
        || result.status === ResponseStatus.success.value) {
        return Promise.resolve(result)
      }
      console.error('【ERROR】' + result.msg);
      Message.error(result.msg)
      return Promise.reject(result)
    },
    error => {
      store.dispatch('doLoading', false).then(r => {})
      if (error.response) {

        if (process.env.VUE_APP_ENV !== "production") {
          try {
            // console.log('API接口返回：【' + error.response.config.url + "】=====>", JSON.stringify(error.response));
          } catch (err) {
            console.log(err)
          }
        }

        let status = error.response.status
        let result = error.response.data;

        if (status === 401) {
          handleLogout(result);
          return Promise.reject(result.msg)
        } else if (status === 404) {
          Message.error("接口不存在，" + error.response.statusText)
          return Promise.reject(ResponseStatus.error.text)
        } else if (status === 500) {
          console.log('服务器异常',error)
          Message.error("服务器异常")
          return Promise.reject(ResponseStatus.error.text)
        } else if (status === 504) {
          console.log('网关超时',error)
          Message.error("网关超时-504 Gateway Time-out")
          return Promise.reject(ResponseStatus.error.text)
        } else {
          if(result) {
            if(result.status !== ResponseStatus.success.value
              || result.state !== ResponseStatus.success.value ) {
              Message.error(result.msg)
            }
            return Promise.reject(result)
          }
          console.log('服务器异常:', error)
          // 弹出消息
          Message.error(error.msg)
          return Promise.reject(ResponseStatus.error.text)
        }
      } else if (error.status === 404) {
        Message.error("接口不存在，" + error.statusText)
        return Promise.reject(ResponseStatus.error.text)
      } else {
        if (error.code == 'ECONNABORTED' && error.msg) {
          // timeout
          console.log('服务器异常:',error)
          // 弹出消息
          Message.error("服务器请求超时")
          return Promise.reject(ResponseStatus.error.text)
        }
      }
    }
);

/***
 * 处理logout
 * @param result
 */
function handleLogout(result) {
  // jum to login
  if (!isShowLoginTip) {
    isShowLoginTip = true;
    MessageBox.confirm(
      '登录状态已过期，您可以继续留在该页面，或者重新登录',
      '系统提示',
      {confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning'}
    ).then(() => {
      isShowLoginTip = false;
      // if (window.location.pathname.indexOf("/login") !== 0) {
      //   let redirectUrl = window.location.pathname + (window.location.search ? window.location.search : '');
      //   location.href = '/login?redirect=' + encodeURI(redirectUrl);
      // }
      location.href = result.data;
    }).catch(() => {
      isShowLoginTip = false;
    })
  }
}

/**
 * 通用下载方法（post/json提交）
 * @param url
 * @param jsonData
 * @param filename
 * @returns {Promise<unknown>}
 */
let downloadLoadingInstance;

// 通用下载方法 表单参数提交
instance['downloadForm'] = function(url, jsonData) {
  downloadLoadingInstance = Loading.service({text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0,0,0,0.7)",})
  return instance.post(url, qs.stringify(jsonData), {
    responseType: 'blob',
    timeout: 300000
  }).then(async (response) => {
    downloadResponse(response, null);
    downloadLoadingInstance.close();
  }).catch((err) => {
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}

// 通用下载方法 JSON参数提交
instance['download'] = function (url, jsonData, filename) {
  console.log("开始下载", url)
  downloadLoadingInstance = Loading.service({text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0,0,0,0.7)",})
  return instance.post(url, jsonData, {
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
    timeout: 10 * 60 * 1000
  }).then(async (response) => {
    let promise = downloadResponse(response, filename);
    downloadLoadingInstance.close();
    return promise;
  }).catch((err) => {
    downloadLoadingInstance && downloadLoadingInstance.close();
    if(err && err.msg) {
      return Promise.reject(err);
    } else {
      Message.error('下载文件出现错误，请联系管理员！')
    }
  })
}

// 通用下载方法回调方法
async function downloadResponse(response, filename) {
  let data = response.data;
  // Content-Disposition: attachment;filename= + fileName
  console.log('API接口接收文件对象' + response.headers['content-disposition'])
  let contentDisposition = response.headers['content-disposition'];
  if (contentDisposition) {
    filename = contentDisposition.split(";")[1].split("=")[1];
    filename = decodeURI(filename);
  }

  const isBlob = await blobValidate(data);
  if (isBlob) {
    const blob = new Blob([data])
    // let blob = new Blob([data], {type: "application/vnd.ms-excel"});
    // let blob = new Blob([data], {type: "application/octet-stream"});
    saveAs(blob, filename)
    return Promise.resolve(true);
  } else {
    const resText = await data.text();
    console.log("----return json-----", resText)
    const result = JSON.parse(resText);
    if (result.status === ResponseStatus.success.value) {
      result.msg && Message.success(result.msg)
      return Promise.resolve(result);
    } else {
      result.msg && Message.error(result.msg)
      return Promise.reject(result);
    }
  }
}

// 验证是否为blob格式
async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}


/**
 * 参数处理
 * @param {*} params  参数
 */
function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    let part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            let subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}


export default instance;
